/** Signed-out page (design: signed-out.html). The session was already ended by ~/app/session.signOutEverywhere. */
import { SUPPORT_EMAIL } from '@/config/brandConfig'
import { outSprite } from '~/design/sprites'
import { Sprite } from '~/app/ui'
import { Falling } from './Falling'

const I = ({ id }: { id: string }) => <svg className="icon" aria-hidden="true"><use href={`#${id}`} /></svg>

export function SignedOut() {
  const at = new URLSearchParams(location.search).get('at')
  const t = (at ? new Date(at) : new Date()).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  return (
    <div className="cw-out">
      <Sprite svg={outSprite} />
      <Falling />
      <main className="stage">
        <section className="copy">
          <a className="wordmark" href="/" aria-label="caryn’s world, back to the enter page">caryn’s world <I id="i-heart" /></a>
          <p className="eyebrow">Invite-only community</p>
          <div className="flourish" aria-hidden="true"><I id="i-heart" /></div>
          <div className="card">
            <div className="seal" aria-hidden="true"><I id="i-lock" /></div>
            <h1>You’re signed out</h1>
            <p className="note">Come back soon...</p>
            <a className="btn" href="/">back to enter page <I id="i-arrow" /></a>
            <p className="stamp">Signed out on this device <span>at {t}.</span></p>
          </div>
          <a className="support" style={{ textDecoration: 'none' }} href={`mailto:${SUPPORT_EMAIL}`}><I id="i-help" />Support</a>
        </section>
        <div className="pumpkin"><img src="/design/pumpkin.webp" width={640} height={529} alt="A hand-drawn autumn pumpkin with a heart-shaped vine and leaf" /></div>
      </main>
    </div>
  )
}
